import { LAYERS } from 'app/utils/maps/layer/layerUtils';

LAYERS.related_sub_entity = 'related_sub_entity'; 

export const Z_INDEX_INCREMENT = 5;

export const SUB_LAYER_OFFSETS = {
    HEATMAP: -1,     
    ENTITY: 2,       
    RELATED: 3,      
};

export const LAYER_SUB_TYPE_MAP = {
    'entity': SUB_LAYER_OFFSETS.ENTITY,
    'event': SUB_LAYER_OFFSETS.ENTITY,
    'heatmap': SUB_LAYER_OFFSETS.HEATMAP,
    'related_sub_entity': SUB_LAYER_OFFSETS.RELATED
};

/**
 * Calculate z-index for a layer based on its position in the layer stack
 * 
 * @param {number} position - Position in the layer stack (0 is first/top layer, higher numbers are lower)
 * @param {string} layerType - Optional layer type to determine increment ('entity', 'event' use larger increment)
 * @returns {number} - Calculated base z-index value
 */
export const calculateLayerZIndex = (position = 0) => {
    const increment = Z_INDEX_INCREMENT;
    
    return 5 + (position * increment);
};

/**
 * Utility to determine the correct zIndex for a new layer.
 * @param {number} zIndex - Explicit zIndex (if provided)
 * @param {Object} mapInstance - Map controller instance (should have getLayersGroup)
 * @param {string|number} fallbackType - fallback type or position for calculateLayerZIndex (must be provided by caller)
 * @returns {number} - Calculated zIndex
 */
export const getLayerZIndex = (zIndex, mapInstance, fallbackType) => {
    if (typeof zIndex === 'number') return zIndex;
    const layersGroup = mapInstance?.getLayersGroup?.('allLayers');
    const count = layersGroup?.getLayers?.().getArray?.().length;
    return typeof count === 'number'
        ? calculateLayerZIndex(count)
        : calculateLayerZIndex(fallbackType);
};

/**
 * Calculate z-index for a sub-layer based on parent layer's z-index and sub-layer type
 * 
 * @param {number} parentZIndex - The z-index of the parent layer
 * @param {string} subLayerType - The type of sub-layer ('heatmap', 'entity', 'related_sub_entity')
 * @returns {number} - Calculated z-index for the sub-layer
 */
export const calculateSubLayerZIndex = (parentZIndex, subLayerType) => {

    const offset = LAYER_SUB_TYPE_MAP[subLayerType] || 0;
    return parentZIndex + offset;
};

/**
 * Apply z-index to a layer
 * @param {Object} layer - OpenLayers layer object with setZIndex method
 * @param {number} zIndex - The z-index value to apply
 */
export const applyLayerZIndex = (layer, zIndex) => {
    if (typeof zIndex === 'number' && layer?.setZIndex) {
        layer.setZIndex(zIndex);
    }
};

export default {
    calculateLayerZIndex,
    calculateSubLayerZIndex,
    applyLayerZIndex,
};